/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarCard\CarCard.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import React from "react";
import CarInfo from "Content/Car/CarInfo/CarInfo";
import CarCost from "Content/Car/CarCost/CarCost";
import CarImgSlider from "Content/Car/CarImgSlider/CarImgSlider";
import styles from "Content/Car/CarCard/CarCard.module.css";
import { CarCardPropsType } from "Content/Car/CarCard/CarCard.type";
import CarCardHeader from "Content/Car/CarCardHeader/CarCardHeader";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { Link } from "react-router-dom";

function CarCard(props: CarCardPropsType) {
    return (
        <React.Fragment>
            <Link to={`${RouterPathResolver.routeCars.path}/${props.id.toString()}`} className={`${styles.superLink}`}>
                <div className={`${styles.car_card_holder}`}>
                    <div className={`${styles.car_card}`}>
                        <CarCardHeader {...props.iconSubSection} themeColor={props.themeColor ?? ""} id={props.id} IsFav={props.IsFav ?? false}/>
                        <CarImgSlider {...props.carImg}/>
                        <div className={`${styles.posCarCost}`}>
                            <CarCost {...props.carCost} themeColor={props.themeColor}/>
                        </div>
                        <div className={`${styles.posCarInfo}`}>
                            <CarInfo hasEllipsis={props.hasEllipsis} Park={""} Color={""} Car_Type={""} Nb_Col={2} Nb_Elem={4} themeColor={props.themeColor} {...props.carInfo} />
                        </div>
                    </div>
                </div>
            </Link>
        </React.Fragment>
    );
}

export default CarCard;
